import React from "react";
import { useNavigate } from "react-router-dom";
import { LuMedal } from "react-icons/lu";
import { IoSpeedometerOutline } from "react-icons/io5";
import { useSelector } from "react-redux";
import { SlNotebook } from "react-icons/sl";
import { GrDocument } from "react-icons/gr";
const InstituteMenu = (props) => {
    const navigate = useNavigate();
    const items = useSelector((state) => state.userDetailsData.LoginDetails);

    return (
        <>
         <div onClick={() => navigate("/Institution/Assessments Participation")}
                className={props.CheckPath("/Institution/Assessments%20Participation") ? "SubTabSelect" : "TabNotSelect"} >  <GrDocument />  Assessments Participation </div>

{items?.instituteId === 1 && 
            <div onClick={() => navigate("/InstitutionReports")}
                className={props.CheckPath("/InstitutionReports") ? "SubTabSelect" : "TabNotSelect"} >  <SlNotebook />  Reports </div>
}
            <div onClick={() => navigate("/InstitutionAdmin")}
                className={
                    props.CheckPath("/Performance") || props.CheckPath("/InstitutionReports") || props.CheckPath("/Institution/Assessments%20Participation")
                        ? "TabNotSelect" : "SubTabSelect"} >  <LuMedal />  Participation </div>

            <div onClick={() => {
                localStorage.removeItem("PerformanceDate");
                items?.userTypeId === 8
                    ? navigate("/InstitutionAdmin/Performance/RegionPerformanceDetails/StatePerformanceDetails")
                    : navigate("/InstitutionAdmin/Performance");
            }}
                className={props.CheckPath("/Performance") ? "SubTabSelect" : "TabNotSelect"} >
                <IoSpeedometerOutline /> Performance
            </div>
        </>
    );
};
export default InstituteMenu;